export class KeyboardEvent extends createjs.Event {
    public static KEY_UP: string = "keyUp";
    public static KEY_DOWN: string = "keyDown";


    constructor(type: string, bubbles: boolean = true, cancelable: boolean = false, charCodeValue: number = 0, keyCodeValue: string = "") {
        super(type, bubbles, cancelable);
        this.keyCode = keyCodeValue;
        this.charCode = charCodeValue;
        this.key = keyCodeValue;
        this.code = keyCodeValue;
    }

    keyCode: string;
    charCode = 0;
    key: string;
    code: string;
    which: number;
    altKey: boolean = false;
    ctrlKey: boolean = false;
    shiftKey: boolean = false;

    public clone(): KeyboardEvent {
        return Object.assign(new KeyboardEvent(this.type, this.bubbles, this.cancelable), this);
    }
}

